import { useState } from 'react';

import { InfoOutlined } from '@mui/icons-material';
import { Chip, ChipProps, IconButton } from '@mui/material';
import { GridRowModel } from '@mui/x-data-grid-pro';

import { ListagemProvider } from 'context/ListagemContext';
import { DetalhamentoCreditosImportacaoValidacaoModal } from 'pages/financeiro/detalhamento-creditos/importar/components';
import { brlPercentual } from 'util/format';

const colors: Record<string, ChipProps['color']> = {
    1: 'info', // AGUARDANDO = 1,
    2: 'info', // PROCESSANDO = 2,
    3: 'success', // SUCESSO = 3,
    4: 'error', // ERRO = 4,
    5: 'error', // FINALIZADO COM ALERTA = 5,
} as const;

export function DetalhamentoCreditosImportacaoStatusColumn({ row }: { row: GridRowModel }) {
    // 4 = ERRO, 5 = FINALIZADO COM ALERTA
    const hasValidations = Boolean([4, 5].includes(row.idStatusProcessamento));
    const [openModal, setOpenModal] = useState(false);

    let dsStatusProcessamento = row.dsStatusProcessamento;

    // 2 = Processamento
    if ( row.idStatusProcessamento === 2 ) {
        dsStatusProcessamento = `${dsStatusProcessamento} ${brlPercentual(row.peProcessamento.toFixed(0))}`;
    }

    return (
        <>
            <Chip label={dsStatusProcessamento} variant="outlined" size="small" color={colors[row.idStatusProcessamento]} />

            {hasValidations && (
                <>
                    <ListagemProvider>
                        <DetalhamentoCreditosImportacaoValidacaoModal
                            open={openModal}
                            setOpen={setOpenModal}
                            idDetalhamentoCreditoDebitoImportacao={row.idDetalhamentoCreditoDebitoImportacao}
                        />
                    </ListagemProvider>

                    <IconButton onClick={() => setOpenModal(true)}>
                        <InfoOutlined color="error" sx={{ fontSize: '1.25rem' }} />
                    </IconButton>
                </>
            )}
        </>
    );
}
